import React from 'react';

// Inline −/+ counter with min/max bounds. Controlled — caller owns the
// `value` and supplies onChange. Disabled buttons render in textMuted
// with not-allowed cursor when at bounds. Optional `helperText` renders
// alongside (used by the forge for compact count descriptors).
// Generalized from prototypes/campaign-creation-prototype.jsx lines 2209-2263.
export const Incrementer = ({
  value,
  onChange,
  min = 0,
  max = 99,
  theme,
  helperText,
  ariaLabel = 'Counter',
}) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const atMin = value <= min;
  const atMax = value >= max;
  const dec = () => { if (!atMin) onChange(value - 1); };
  const inc = () => { if (!atMax) onChange(value + 1); };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div
        role="group"
        aria-label={ariaLabel}
        style={{
          display: 'inline-flex', alignItems: 'stretch',
          background: c.bgInput,
          border: `1px solid ${c.borderLight}`,
          borderRadius: 6,
          overflow: 'hidden',
        }}
      >
        <button
          type="button"
          onClick={dec}
          disabled={atMin}
          aria-label="Decrement"
          style={{
            padding: '0 10px',
            background: 'transparent',
            borderTop: 'none',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: `1px solid ${c.borderLight}`,
            color: atMin ? c.textMuted : c.accentLight,
            fontFamily: t.headingFamily,
            fontSize: '1.2rem',
            fontWeight: 700,
            cursor: atMin ? 'not-allowed' : 'pointer',
          }}
        >−</button>
        <div
          aria-live="polite"
          style={{
            padding: '6px 16px',
            fontFamily: t.headingFamily,
            fontSize: '1rem',
            fontWeight: 700,
            color: c.textPrimary,
            minWidth: 38,
            textAlign: 'center',
          }}
        >{value}</div>
        <button
          type="button"
          onClick={inc}
          disabled={atMax}
          aria-label="Increment"
          style={{
            padding: '0 10px',
            background: 'transparent',
            borderTop: 'none',
            borderRight: 'none',
            borderBottom: 'none',
            borderLeft: `1px solid ${c.borderLight}`,
            color: atMax ? c.textMuted : c.accentLight,
            fontFamily: t.headingFamily,
            fontSize: '1.2rem',
            fontWeight: 700,
            cursor: atMax ? 'not-allowed' : 'pointer',
          }}
        >+</button>
      </div>
      {helperText && (
        <span style={{
          fontFamily: t.fontFamily,
          fontSize: '0.82rem',
          color: c.textMuted,
        }}>{helperText}</span>
      )}
    </div>
  );
};
